import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { Fatura } from '../../model/fatura';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { FaturamentoService } from '../../shared/faturamento.service';
import { OverlaySpinnerService } from '../../shared/overlay-spinner.sevice';

@Component({
  selector: 'mti-lista-faturas',
  templateUrl: './lista-faturas.component.html',
  styleUrls: ['./lista-faturas.component.css']
})
export class ListaFaturasComponent implements OnChanges {

  @Input() faturas!: Fatura[];

  enviandoEmail = false;

  constructor(private faturamentoService: FaturamentoService, private dialog: MatDialog, private overlaySpinnerService: OverlaySpinnerService, private snackBar: MatSnackBar) { }

  displayedColumns: string[] = ['selecionado', 'FaturaId', 'Contrato', 'Competencia', 'Vencimento', 'Liberada', 'Inicio', 'Fim', 'Valor', 'DataEmail', 'statusOperacao'];

  dataSource!: MatTableDataSource<Fatura>;
  selection = new SelectionModel<Fatura>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  isAnySelected() {
    return this.selection.selected.length > 0;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  enviarSelecionadasClicado() {
    this.enviandoEmail = true;

    this.abreModalConfirmacaoEnvioDeEmails();
   
  }

  enviarELiberarSelecionadasClicado() {
    this.enviandoEmail = true;

    this.abreModalConfirmacaoLiberacaoEEnvioDeEmails();

  }

  abreModalConfirmacaoEnvioDeEmails(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { titulo: "Enviar emails", pergunta: "Confirma o envio dos emails selecionados?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        this.enviarEmailsSelecionados();
      }
    });
  }

  abreModalConfirmacaoLiberacaoEEnvioDeEmails(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { titulo: "Enviar emails", pergunta: "Confirma a liberação e o envio dos emails selecionados?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        this.enviarEmailsSelecionados(true);
      }
    });
  }

  enviarEmailsSelecionados(liberar=false) {

    const faturasSelecionadas = this.selection.selected;
    
    this.overlaySpinnerService.showSpinner();

    this.faturamentoService.enviarEmails(faturasSelecionadas, liberar)
      .subscribe(resultados => {

        resultados.enviados.forEach(enviado => {
          var fatura = faturasSelecionadas.find(f => enviado.faturaId === f.FaturaId);
          if (fatura) {
            fatura.DataEmail = enviado.dataEnvioEmail;
            if (liberar) fatura.Liberada = new Date();
          }
        });

        resultados.naoEnviados.forEach(naoEnviado => {
          var fatura = faturasSelecionadas.find(f => naoEnviado.faturaId === f.FaturaId);
          if (fatura) {
            fatura.statusOperacao = naoEnviado.mensagem;
          }
        });

        var comErro = resultados.naoEnviados && resultados.naoEnviados.length === 0 ? '' : ' Mas com alguns erros.';

        this.enviandoEmail = false;
        this.overlaySpinnerService.stopSpinner();

        const snackRef = this.snackBar.open('emails enviados.' + `${comErro}`, 'ok', {
          duration: 8 * 1000,
        });

        snackRef.onAction().subscribe(() => {
          snackRef.dismiss();
        });
        
      },
        error => {
          this.enviandoEmail = false;
          this.overlaySpinnerService.stopSpinner();

          const snackRef =  this.snackBar.open('erro ao enviar os emails:' + error, 'fechar', {
            duration: 6 * 1000,
          });

          snackRef.onAction().subscribe(() => {
            snackRef.dismiss();
          });
        });
  }

  DateToMMDDYYYYHHMM(Date: Date): string {
    let DS: string =  ('0' + Date.getDate()).slice(-2)
      + '/' + ('0' + (Date.getMonth() + 1)).slice(-2)
      + '/' + Date.getFullYear()
      + ' ' + ('0' + Date.getHours()).slice(-2)
      + ':' + ('0' + Date.getMinutes()).slice(-2)
    return DS
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['faturas'] && changes['faturas'].previousValue != changes['faturas'].currentValue) {
      this.dataSource = new MatTableDataSource<Fatura>(this.faturas);
      this.selection = new SelectionModel<Fatura>(true, []);
    }
  }

}
